import { useState, useEffect } from "react";
import { useStore } from "react-redux";
import { Modal as bsModal } from "bootstrap";

import console from "../functions/console";
import { ModalLayout } from "../../popups/ModalLayout";
import { configActions, basketActions, pageActions } from "../../actions";

const MODAL_ID = "TimeoutPopup";

const getSessionTimeout = (sessionStart, timeout) => {
  const time = Date.now();
  timeout = timeout * 1000 + sessionStart;
  timeout = Math.floor((timeout - time) / 1000);
  return timeout > 0 ? timeout : 0;
};

const Timeout = (props) => {
  const { configStorage } = useStore().getState();
  const dispatch = useStore().dispatch;
  const { sessionStart, timeout, warningTime, isActive } = configStorage.getSessionData();
  const startPage = configStorage.getBackToLandingPageLink();
  const openPopup = configStorage.getTimoutPopupStatus();
  let { className } = props;
  className = className ? className + " ser-timeout" : "ser-timeout";

  const [seconds, setSeconds] = useState(timeout);
  const [popup, setPopup] = useState(false);

  const resetSession = async () => {
    dispatch(
      configActions.restartSession(configStorage.getRequestData("session_ping"))
    );
    const modal = document.querySelector("#" + MODAL_ID);
    if (modal) {
      bsModal.getOrCreateInstance(modal).hide();
    }
    setPopup(false);
  };

  const restartVerseNeoSession = (e) => {
    if (configStorage.isVerseNeo()) {
      dispatch(configActions.setRenderLandingPage(true));
    }
    dispatch(pageActions.setOverviewPage());
    dispatch(basketActions.resetWarenkorb());
  };

  useEffect(() => {
    let seconds = getSessionTimeout(sessionStart, timeout);
    let interval = null;
    if (seconds > 0) {
      interval = setInterval(() => {
        seconds = seconds - 1;
        if (!popup && seconds <= warningTime) {
          setPopup(true);
          if (openPopup !== "opened") {
            dispatch(configActions.setTimoutPopupStatus("open"));
          }
        }
        if (seconds >= 0) {
          setSeconds(seconds);
        } else {
          clearInterval(interval);
        }
      }, 1000);
      const modal = document.querySelector("#" + MODAL_ID);
      if (modal) {
        if (openPopup === "open") {
          bsModal.getOrCreateInstance(modal).show();
          dispatch(configActions.setTimoutPopupStatus("opened"));
        } else if (openPopup === "close") {
          bsModal.getOrCreateInstance(modal).hide();
          dispatch(configActions.setTimoutPopupStatus("closed"));
        }
      }
    } else {
      console.log("session timeout");
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [popup, warningTime, sessionStart, timeout, openPopup, dispatch]);

  let t = new Date(seconds * 1000);
  let time = t.toISOString().slice(14, 19);

  return (
    <>
      {isActive ? (
        <div className={className} aria-live="off">
          {seconds < timeout && seconds > 0
            ? <span>Timeout: {time} min</span>
            : <span>&nbsp;</span>
          }
          {seconds === 0
            ? <a className="btn btn-default" href={startPage}>
              neue Session starten
            </a>
            : null
          }
        </div>
      ) : null}
      {popup ? (
        <ModalLayout title="Ihre Session läuft aus" id={MODAL_ID}>
          <div className="modal-body">
            {seconds > 0 ? (
              <>
                <p>Achtung! In {time} Minuten wird ihre Session beendet.</p>
              </>
            ) : (
              <p>Ihre Session wurde beendet</p>
            )}
          </div>
          <div className="modal-footer">
            {seconds > 0 ? (
              <button className="btn btn-default" onClick={resetSession}>
                Session fortsetzen
              </button>
            ) : (
              <a className="btn btn-default" href={startPage} onClick={restartVerseNeoSession}>
                neue Session starten
              </a>
            )}
          </div>
        </ModalLayout>
      ) : null}
    </>
  );
};
export default Timeout;
